import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SharedService } from "src/app/shared/services/shared.service";
import { AppLocalStorage } from "src/app/storage-manager/local-storage";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ActivityLogService {
  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
     private appLocalStorage: AppLocalStorage
  ) {}

  fetchAdminActivityLog(
    page: number = 1,
    limit: number = 1000000,
    search?: string,
    startDate?: string,
    endDate?: string,
  ) {
    let params = new HttpParams();
    params = params.append(
      "issuer_code",
      this.sharedService.getSelectedIssuerCodeFromSession(),
    );
    params = params.append(
      "sub_issuer_code",
      this.sharedService.getSelectedSubIssuerCodeFromSession(),
    );
    if (search) {
      params = params.set("search", search);
    }
    if (startDate) {
      params = params.append("startDate", startDate);
    }

    if (endDate) {
      params = params.append("endDate", endDate);
    }
    const roles = this.appLocalStorage.getFromStorage('roles');
  
     if (!roles.includes('superadmin')) {
    params = params.append(
      "country_code",
      this.sharedService.getSelectedCountryFromSession(),
    );
  }
    params = params.append("page", "1");
    params = params.append("limit", "1000000");
    return this.http.get(`${environment.ADMIN_AUTH_URL}/activity-log`, {
      params,
    });
  }
}
